import { Head } from '@inertiajs/react';
import { NoticeErrorBoundary } from '../Components/ErrorBoundaries';
import { LoginForm } from '../Components/Forms';
import { SplitBlock, SplitBlockHeader } from '../Components/SplitBlocks';
import { ReCaptcha } from '../Types';

type LoginProps = {
    recaptcha: ReCaptcha;
};

const Login = ({ recaptcha }: LoginProps) => {
    return (
        <>
            <Head>
                <title>Log In</title>
                <meta
                    name='description'
                    content='Log in to the OTS Commercial Website'
                />
            </Head>

            <SplitBlock
                id='login'
                path='private-hire-jobs-call-centre'
                alt='Onward Travel Solutions Ltd Vision'
                hasTextFormatting={false}
                className='[&>div]:md:flex-row-reverse'
            >
                <SplitBlockHeader
                    className={'text-3xl lg:text-4xl uppercase font-bold'}
                >
                    Log In
                </SplitBlockHeader>

                <NoticeErrorBoundary>
                    <LoginForm
                        {...{
                            recaptcha: recaptcha,
                        }}
                    />
                </NoticeErrorBoundary>
            </SplitBlock>
        </>
    );
};

export default Login;
